import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';
import {downloadFile} from '../../common/util/file';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'listByPage': [],
  'pageSize': 20,
  'pageNumber': 0,
  'downloading': false,
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > pageSize * (pageNumber + 1)) {
    return [...list].slice(pageSize * pageNumber, pageSize * (pageNumber + 1));
  }
  return [...list].slice(pageNumber * pageSize);
};

export const amountReportDetail = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_AMOUNT_REPORT_DETAIL]: (state, action) => INITIAL_STATE,
    [ActionTypes.FETCHING_AMOUNT_REPORT_DETAIL_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_AMOUNT_REPORT_DETAIL_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'listByPage': [...getPage(action.response.data, 0, state.pageSize)],
    }),
    [ActionTypes.FETCHED_AMOUNT_REPORT_DETAIL_LIST_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      'loading': false,
      'list': [],
      'listByPage': [],
    }),
    [ActionTypes.CHANGE_AMOUNT_REPORT_DETAIL_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
      'listByPage': [...getPage(state.list, action.payload, state.pageSize)],
    }),
    [ActionTypes.CHANGE_AMOUNT_REPORT_DETAIL_LIST_PAGE_SIZE]: (
      state,
      action
    ) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
      'listByPage': [...getPage(state.list, 0, action.payload)],
    }),
    [ActionTypes.DOWNLOAD_AMOUNT_REPORT_DETAIL]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOAD_AMOUNT_REPORT_DETAIL_SUCCESS]: (state, action) => {
      downloadFile(action.response.data);
      return {
        ...state,
        'downloading': false,
      };
    },
    [ActionTypes.DOWNLOAD_AMOUNT_REPORT_DETAIL_ERROR]: (state, action) => ({
      ...state,
      'downloading': false,
    }),
  })(state, action);
};
